import React from 'react';

import { VerificationRequestStatus } from 'src/api';
import { useInboxItemParamId } from 'src/hooks/inboxItem';
import { useVerificationRequest } from 'src/hooks/verificationRequest';

import { EmployeeToRespondContent } from './EmployeeToRespondContent';
import { ReportCreatedContent } from './ReportCreatedContent';

export const RequestContent: React.FC = () => {
  const inboxItemId = useInboxItemParamId();
  const { verificationRequest } = useVerificationRequest({ inboxItemId });

  const verificationRequestStatus = verificationRequest?.status;

  switch (verificationRequestStatus) {
    case VerificationRequestStatus.EmployeeToRespond: {
      return <EmployeeToRespondContent />;
    }
    case VerificationRequestStatus.ReportCreated: {
      return <ReportCreatedContent />;
    }
    case VerificationRequestStatus.ReviewedByVerifier: {
      return <ReportCreatedContent />;
    }
    default: {
      return null;
    }
  }
};
